import { render, staticRenderFns } from "./errorsDiv.vue?vue&type=template&id=96fd99ba&scoped=true"
import script from "./errorsDiv.vue?vue&type=script&lang=js"
export * from "./errorsDiv.vue?vue&type=script&lang=js"
import style0 from "./errorsDiv.vue?vue&type=style&index=0&id=96fd99ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fd99ba",
  null
  
)

export default component.exports